export enum CountryCode {
  /**
   * @description 馬來西亞
   */
  MALAYSIA = 'MY',
  /**
   * @description 柬埔寨
   */
  CAMBODIA = 'KH',
  /**
   * @description 菲律賓
   */
  PHILIPPINES = 'PH',
  /**
   * @description 印度尼西亞
   */
  INDONESIA = 'ID',
}
